import { styled } from '@mui/material'

export const Wrapper = styled('div')(({ theme }) => ({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',

  // No mobile o conteudo e mais alto que o modal: com `height: 100%` o flex
  // esmagava resumo e chips (os chips apareciam cortados pela metade). Altura
  // automatica deixa cada bloco no tamanho natural e quem rola e o ModalContent.
  [theme.breakpoints.down('sm')]: {
    height: 'auto'
  }
}))

export const ToolbarContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: '16px',
  marginTop: '4px',
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column-reverse',
    gap: '12px'
  }
}))

export const TableWrapper = styled('div')(({ theme }) => ({
  flex: 1,
  overflowY: 'auto',
  '& tr:hover': {
    cursor: 'pointer',
    background: theme.palette.neutral[800]
  },

  // No modal curto do mobile o `flex: 1` sobrava alguns pixels e a tabela
  // aparecia so pelo topo do header. Com altura minima ela fica utilizavel e
  // quem rola e o ModalContent.
  [theme.breakpoints.down('sm')]: {
    minHeight: 260
  }
}))

export const EmptyWrapper = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  width: '100%'
}))
